import { AxiosError } from 'axios'
import { useFeedback } from 'context'
import { ApiResponseTypes, AssignmentServices } from 'services'
import { useQuery } from 'react-query'

export const useAssignmentByIdQuery = (assignmentId: number) => {
  const { alert } = useFeedback()

  const assignmentByIdQuery = useQuery({
    queryKey: ['/assignments/assignmentId', assignmentId],
    queryFn: () => AssignmentServices.id.get(assignmentId),
    enabled: !!assignmentId,
    onError: (error: AxiosError<ApiResponseTypes<unknown>>) => {
      alert.showError(error.response?.data.message || error.message)
    }
  })

  return assignmentByIdQuery
}
